export default __webpack_public_path__ + "static/media/addEnable.715e46e5.svg";